import { API_URLS } from '../configuration/apiConstants';
import { apiFetch } from '../configuration/apiFetch';
import { useSessionStore } from '../store/sessionStore';


export const getSaveOptions =  () => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.ITEMS_MOTIONS,
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const saveMapMotion =  ({data, motionId=false, successMsg}) => {
  const myStore = useSessionStore.getState().myStore
  const user = useSessionStore.getState().user
  const theData = {
    ...data,
    userId: user,
    storeId:myStore.id
  }
  const fetchSettings = {
    method: !motionId ? "POST" : "PUT",
    url: !motionId ? API_URLS.NEW_MOTION : API_URLS.MOTION(motionId),
    data: theData,
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}